document.addEventListener('DOMContentLoaded', function () {
  let state = false;
  let pos = 0;

  const menuBtn = document.getElementById('menuBtn');
  const menuNav = document.getElementById('menuNav');
  const body = document.body;

  menuBtn.addEventListener('click', function () {
    // トグルでクラスを付け替える
    this.classList.toggle('is-open');
    menuNav.classList.toggle('is-open');

    if (!state) {
      // メニューを開くとき
      pos = window.scrollY;
      body.classList.add('is-fixed');
      body.style.top = `-${pos}px`;
      state = true;
    } else {
      // メニューを閉じるとき
      body.classList.remove('is-fixed');
      body.style.top = '';
      window.scrollTo(0, pos); // 元のスクロール位置に戻す
      state = false;
    }
  });
});
window.addEventListener('load', function () {
  document.documentElement.classList.add('is-actv');
});
class ScrollManager {
  
  constructor(containerSelector, navSelector, sectionSelector, pageTopId) {
    this.container = document.querySelector(containerSelector);
    this.nav = document.getElementById(navSelector);
    this.sections = document.querySelectorAll(sectionSelector);
    this.buttons = this.nav.querySelectorAll('button');
    this.pageTopButton = document.getElementById(pageTopId);
    this.originalParent = this.nav.parentNode;
    this.isSP = window.innerWidth <= 750; // 初期SP判定
    this.navInitialOffset = 0; // 初期値は0に設定
    this.lastScrollPosition = 0; // 最後のスクロール位置を記録
    this.init();
  }

  calculateNavInitialOffset() {
    if (this.isSP) {
      const navRect = this.nav.getBoundingClientRect(); // ビューポート基準の位置を取得
      const offset = navRect.top + window.scrollY; // SP版はwindow.scrollY基準
      return offset;
    } else {
      const navRect = this.nav.getBoundingClientRect();
      const containerRect = this.container.getBoundingClientRect();
      const offset = navRect.top - containerRect.top + this.container.scrollTop; // PC版はコンテナ基準
      return offset;
    }
  }

  init() {
    window.addEventListener('load', () => {
      this.navInitialOffset = this.calculateNavInitialOffset(); // ページロード完了後に初期位置を計算
    });

    const scrollTarget = this.isSP ? window : this.container;

    scrollTarget.addEventListener('scroll', () => {
      this.handleScroll();
    });

    this.buttons.forEach((button) =>
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.scrollToSection(button.dataset.nav, -120);
      })
    );
    if (this.pageTopButton) {
      this.pageTopButton.addEventListener('click', () => this.scrollToTop());
    }
    this.updateSectionOffsets();
    window.addEventListener('resize', () => {
      this.isSP = window.innerWidth <= 750; // リサイズでSP判定更新
      this.navInitialOffset = this.calculateNavInitialOffset(); // リサイズ時も初期位置を再計算
      this.moveNav();
    });
    this.moveNav();
  }

  handleScroll() {
    const currentScrollPosition = this.isSP ? window.scrollY : this.container.scrollTop;
    const scrollDirection = currentScrollPosition > this.lastScrollPosition ? 'down' : 'up';
    this.lastScrollPosition = currentScrollPosition;
    this.updateCurrentSection();
  }

  scrollToTop(offset = 0) {
    const scrollTarget = this.isSP ? window : this.container;
    scrollTarget.scrollTo({
      top: offset,
      behavior: 'smooth',
    });
  }

  scrollToSection(sectionId, offset = 0) {
    const section = document.getElementById(sectionId);
    if (section) {
      const sectionPosition = section.offsetTop + offset;
      if (this.isSP) {
        window.scrollTo({
          top: sectionPosition,
          behavior: 'smooth',
        });
      } else {
        this.container.scrollTo({
          top: sectionPosition,
          behavior: 'smooth',
        });
      }
    }
  }

  updateCurrentSection() {
    const scrollPosition = this.isSP ? window.scrollY : this.container.scrollTop;
    let currentSectionButton = null;

    this.sections.forEach((section) => {
      const sectionOffsetTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      if (
        scrollPosition + 160 >= sectionOffsetTop &&
        scrollPosition < sectionOffsetTop + sectionHeight
      ) {
        const button = Array.from(this.buttons).find(
          (button) => button.dataset.nav === section.id
        );
        if (button) currentSectionButton = button;
      }
    });

    this.buttons.forEach((button) => button.classList.remove('is-current'));
    if (currentSectionButton) currentSectionButton.classList.add('is-current');
  }

  updateSectionOffsets() {
    this.sections.forEach((section) => {
      section.dataset.offsetTop = section.offsetTop;
    });
  }
  
  moveNav() {
    const introElement = document.getElementById('intro'); // id="intro"を持つ要素を取得
    if (window.innerWidth <= 750) {
      if (this.nav.parentNode !== introElement.parentNode) {
        introElement.insertAdjacentElement('afterend', this.nav); // 閉じタグ直後に移動
      }
    } else {
      if (this.nav.parentNode !== this.originalParent) {
        this.originalParent.insertBefore(
          this.nav,
          this.originalParent.querySelector('.l-container__curtain2')
        );
      }
    }
  }

  debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}

const scrollManager = new ScrollManager('.l-content', 'nav', '.l-section', 'pageTop');

// `scrollToSection` と `scrollToTop` をグローバルに公開
window.scrollToSection = (sectionId, offset = 0) => {
  scrollManager.scrollToSection(sectionId, offset);
};

window.scrollToTop = (offset = 0) => {
  scrollManager.scrollToTop(offset);
};
